import React from "react";
import { EntityChipShell, Text } from "@salestrak/ui";

import { resolveEntityLabel, type EntityData } from "#app/lib/entity-visuals";
import { EntityVisual } from "./entity-visual";
import type { Omittable } from "@salestrak/ui";

export type EntityBreadcrumbLinkProps = Omittable<{
  entity: EntityData;
  onClick?: () => void;
  active?: boolean;
}>;

// The entity system's breadcrumb segment: keeps the glyph and label on the
// canonical resolution path rather than decomposing a visual into BreadcrumbLink
// icon/iconColor primitives. Renders through the entity shell at `size="xs"` so
// the crumb borrows the ghost-button geometry and lines up with the view tabs
// beneath it. EntityVisual is render-only, so it nests safely in the shell's row.
export function EntityBreadcrumbLink({
  entity,
  onClick,
  active,
}: EntityBreadcrumbLinkProps) {
  return (
    <EntityChipShell as="box" size="xs" onClick={onClick}>
      <EntityVisual entity={entity} size="sm" />
      <Text size="sm" variant={active ? undefined : "muted"} truncate={1}>
        {resolveEntityLabel(entity)}
      </Text>
    </EntityChipShell>
  );
}
